import { Fragment } from "react";
import { 
  Dialog, 
  DialogPanel, 
  DialogTitle,
  Transition, 
  TransitionChild,
} from "@headlessui/react";
import { XMarkIcon } from "@heroicons/react/24/outline";
import { Button } from "components/ui";
import { Input } from "components/ui/Form";

export function EmailSampleModal({ show, onClose }) {
  return (
    <Transition show={show} as={Fragment}>
      <Dialog as="div" className="relative z-[410]" onClose={onClose}>
        <TransitionChild
          as={Fragment}
          enter="ease-out duration-300"
          enterFrom="opacity-0"
          enterTo="opacity-100"
          leave="ease-in duration-200"
          leaveFrom="opacity-100"
          leaveTo="opacity-0"
        >
          <div className="fixed inset-0 bg-slate-900/40 backdrop-blur-sm transition-opacity dark:bg-black/60" />
        </TransitionChild>

        <div className="fixed inset-0 z-10 overflow-hidden text-left">
          <div className="flex min-h-full items-center justify-center p-4 text-center sm:p-0">
            <TransitionChild
              as={Fragment}
              enter="ease-out duration-300"
              enterFrom="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
              enterTo="opacity-100 translate-y-0 sm:scale-100"
              leave="ease-in duration-200"
              leaveFrom="opacity-100 translate-y-0 sm:scale-100"
              leaveTo="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
            >
              <DialogPanel className="relative flex w-full max-w-md flex-col overflow-hidden rounded-2xl bg-white text-left shadow-2xl transition-all dark:bg-dark-700 border border-slate-100 dark:border-dark-600 isolate">
                <div className="flex items-center justify-between border-b border-slate-100 px-6 py-4 dark:border-dark-600 bg-slate-50/50">
                  <DialogTitle className="text-lg font-bold text-slate-900 dark:text-white">
                    Email Sample
                  </DialogTitle>
                  <button
                    onClick={onClose}
                    className="rounded-full p-1.5 text-slate-400 hover:bg-slate-100 hover:text-slate-500 dark:text-dark-300 dark:hover:bg-dark-600"
                  >
                    <XMarkIcon className="h-6 w-6" />
                  </button>
                </div>

                <div className="p-6 space-y-4">
                  <p className="text-[11px] font-black text-slate-400 uppercase tracking-widest pl-1">Email Sample</p>
                  <Input label="Email Address *" defaultValue="vishal.panjia@sunnyhomes.com" className="h-10" />
                </div>

                <div className="border-t border-slate-100 p-4 bg-slate-50/50 dark:bg-dark-800/50 flex justify-end gap-2">
                    <Button variant="flat" size="sm" className="font-bold h-9" onClick={onClose}>Cancel</Button>
                    <Button variant="filled" color="primary" size="sm" className="font-bold px-6 h-9" onClick={onClose}>Send Email</Button>
                </div>
              </DialogPanel>
            </TransitionChild>
          </div>
        </div>
      </Dialog>
    </Transition>
  );
}
